import { grey } from "@mui/material/colors";
import { BasketIcon, Box, Grid2, ResetIcon, Typography } from "components";
import { useMutation } from "hooks/useQueries";
import { AdvisorOnboardFormInterface } from "interfaces/OnboardingInterface";
import { useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";
import { numberToCurrency } from "utils";
import axiosInstance from "utils/axiosInstance";
import { handleReturnAmount, refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";

const AdvisorOnboardingPayment = () => {
  const form = useFormContext<AdvisorOnboardFormInterface>();

  const onBoardflowData = useAppSelector(
    (state) => state?.app?.onBoardflowData,
  );

  // ================================================================================================================= clientData={addedClientData}====
  const { mutate: handleSendPaymentLink } = useMutation({
    mutationKey: ["HANDLE_SEND_PAYMENT_LINK"],
    mutationFn: (values: any) =>
      axiosInstance.post(`/api/revenue/onboarding-flow/`, values),
    onSuccess: () => {
      refetchQuery(QueryKeys.GET_COMPLIANCE_BY_CLIENT_ID);
      refetchQuery(QueryKeys.GET_CLIENT_BY_ID);
      form.setValue("activeStep", form.getValues("activeStep") + 1);
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit(() => {
        handleSendPaymentLink({
          isSendEmail: true,
          client: form.getValues("id"),
          basket: form.getValues("basketObject.id"),
          feePlan: form.getValues("selectedFeePlan.id"),
          portfolio: form.getValues("portfolioObject.id"),
          frequency: form.getValues("advanceFeePlan.frequency"),
          advanceFeePlan: null,
          flowType: "Advisor Initiated Advisory Flow",
        });
      })}
      id="advisor-onboarding-payment-form"
    >
      <Grid2
        spacing={2}
        container
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Grid2 size={12}>
          <Typography fontWeight={600} fontSize={16}>
            Payment
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Box
            sx={{
              p: 2,
              background: "var(--neutral-50)",
              borderRadius: 2,
            }}
          >
            <Grid2 container spacing={4}>
              <Grid2 size={12}>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  <Typography fontWeight={700} fontSize={20}>
                    {numberToCurrency(
                      handleReturnAmount({
                        skipAdvanceFee: form.getValues("skipAdvanceFee"),
                        feePlanDetails: form.getValues(
                          "advanceFeePlan.feePlan",
                        ),
                        advanceFeePlan: form.getValues("advanceFeePlan"),
                        planDataObject: form.getValues("planDataObject"),
                        isExitGST: onBoardflowData?.revenueWithGst,
                      }) || 0,
                    )}
                  </Typography>
                  {onBoardflowData?.revenueWithGst && (
                    <Typography fontSize={12} color="#94A3B8">
                      (inclusive of GST)
                    </Typography>
                  )}
                </Box>
                <Typography fontWeight={500} color={grey[400]} fontSize={12}>
                  Amount to Pay
                </Typography>
              </Grid2>
              <Grid2 size={12}>
                <Box display={"flex"} alignItems={"center"} gap={1}>
                  <BasketIcon />
                  <Typography
                    color={"var(--neutral-500)"}
                    fontSize={12}
                    width={"15%"}
                  >
                    Basket Name:
                  </Typography>
                  <Typography fontWeight={600} fontSize={12}>
                    {form.getValues("basketObject.name") || "-"}
                  </Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"} gap={1}>
                  <ResetIcon />
                  <Typography
                    width={"15%"}
                    color={"var(--neutral-500)"}
                    fontSize={12}
                  >
                    Renews every:
                  </Typography>
                  <Typography fontWeight={600} fontSize={12}>
                    {form.getValues("advanceFeePlan.frequency")}
                  </Typography>
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default AdvisorOnboardingPayment;
